/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "API Auth Req";
const frontMatter = {};
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    li: "li",
    mark: "mark",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.p>{"Because the Chronosphere API requires authentication, include an API token with your\n"}<_components.code>{"curl"}</_components.code>{" request, as shown in the following example. For more details, see\n"}<_components.a href="/tooling/api-info#create-an-api-token">{"Create an API token"}</_components.a>{"."}</_components.p>{"\n"}<_components.pre tabIndex="0" data-language="shell" data-word-wrap=""><_components.code><_components.span><_components.span style={{
    "--shiki-dark": "#C6A0F6",
    "--shiki-light": "#D32F2F"
  }}>{"export"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" CHRONOSPHERE_API_TOKEN"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\"TOKEN\""}</_components.span></_components.mark></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#C6A0F6",
    "--shiki-light": "#D32F2F"
  }}>{"export"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#24292EFF"
  }}>{" CHRONOSPHERE_DOMAIN"}</_components.span><_components.span style={{
    "--shiki-dark": "#8BD5CA",
    "--shiki-light": "#D32F2F"
  }}>{"="}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\""}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"INSTANCE"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{".chronosphere.io\""}</_components.span></_components.span>{"\n"}<_components.span>{" "}</_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#8AADF4",
    "--shiki-dark-font-style": "italic",
    "--shiki-light": "#6F42C1",
    "--shiki-light-font-style": "inherit"
  }}>{"curl"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" -H"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"API-Token: "}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#22863A"
  }}>{"${CHRONOSPHERE_API_TOKEN}"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\""}</_components.span><_components.span style={{
    "--shiki-dark": "#F5BDE6",
    "--shiki-light": "#24292EFF"
  }}>{" \\"}</_components.span></_components.span>{"\n"}<_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"     -X"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{" "}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#2B5581"
  }}>{"METHOD"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{" \"https://"}</_components.span><_components.span style={{
    "--shiki-dark": "#CAD3F5",
    "--shiki-light": "#22863A"
  }}>{"${CHRONOSPHERE_DOMAIN}"}</_components.span><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"/"}</_components.span><_components.mark data-highlighted-chars=""><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"ENDPOINT_PATH"}</_components.span></_components.mark><_components.span style={{
    "--shiki-dark": "#A6DA95",
    "--shiki-light": "#22863A"
  }}>{"\""}</_components.span></_components.span></_components.code></_components.pre>{"\n"}<_components.p>{"Replace the following:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li><_components.em><_components.code>{"TOKEN"}</_components.code></_components.em>{": Your API token."}</_components.li>{"\n"}<_components.li><_components.em><_components.code>{"INSTANCE"}</_components.code></_components.em>{": The subdomain name for your organization’s Observability Platform instance."}</_components.li>{"\n"}<_components.li><_components.em><_components.code>{"METHOD"}</_components.code></_components.em>{": The HTTP method to use with the request, such as "}<_components.code>{"GET"}</_components.code>{" or "}<_components.code>{"POST"}</_components.code>{"."}</_components.li>{"\n"}<_components.li><_components.em><_components.code>{"ENDPOINT_PATH"}</_components.code></_components.em>{": The specific endpoint you want to access."}</_components.li>{"\n"}</_components.ul></>;
}

export default MDXLayout